// Soft banner: asks once to use current location for accurate nearby hospitals.
// Shown when location is IP-based or missing. Manual pick always available.
import React, { useState, useEffect } from 'react';
import { MdMyLocation, MdClose } from 'react-icons/md';
import { useLocation } from '../context/LocationContext';

const DISMISS_KEY = 'hcen_loc_prompt_dismissed';

export default function LocationAutoPrompt() {
  const { loc, source, requesting, requestGps, permission } = useLocation();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (permission === 'denied') { setVisible(false); return; }
    if (source === 'gps') { setVisible(false); return; }
    if (requesting) { setVisible(false); return; }
    try {
      if (sessionStorage.getItem(DISMISS_KEY)) return;
    } catch { /* ignore */ }
    // Show when we only have IP / manual / no location
    if (!loc || source === 'ip' || (source === 'manual' && !loc.coords)) {
      const t = setTimeout(() => setVisible(true), 1200);
      return () => clearTimeout(t);
    }
  }, [loc, source, requesting, permission]);

  if (!visible) return null;

  const dismiss = () => {
    try { sessionStorage.setItem(DISMISS_KEY, '1'); } catch {}
    setVisible(false);
  };

  const allow = async () => {
    const next = await requestGps();
    if (next) dismiss();
  };

  return (
    <div style={{
      position: 'fixed', bottom: 88, left: '50%', transform: 'translateX(-50%)',
      zIndex: 8500, width: 'min(420px, calc(100vw - 24px))',
      background: '#fff', borderRadius: 16, padding: '14px 16px',
      boxShadow: '0 8px 32px rgba(0,0,0,0.18)', border: '1px solid #e2e8f0',
      display: 'flex', alignItems: 'flex-start', gap: 12,
    }}>
      <MdMyLocation size={22} style={{ color: '#d32f2f', flexShrink: 0, marginTop: 2 }} />
      <div style={{ flex: 1 }}>
        <div style={{ fontWeight: 700, fontSize: 14, marginBottom: 4 }}>
          Use your current location?
        </div>
        <div style={{ fontSize: 12, color: '#64748b', lineHeight: 1.45, marginBottom: 10 }}>
          For accurate nearby hospitals and distance, allow GPS. You can also pick a city manually anytime.
        </div>
        <div style={{ display: 'flex', gap: 8 }}>
          <button type="button" className="btn btn-primary btn-sm" onClick={allow} disabled={requesting}>
            {requesting ? 'Detecting…' : 'Allow location'}
          </button>
          <button type="button" className="btn btn-ghost btn-sm" onClick={dismiss}>
            Not now
          </button>
        </div>
      </div>
      <button type="button" onClick={dismiss} style={{ background: 'none', border: 'none', cursor: 'pointer', color: '#94a3b8', padding: 4 }}>
        <MdClose size={18} />
      </button>
    </div>
  );
}
